<!-- <csn-loading-spinner></csn-loading-spinner> -->

<!-- Page wrapper for sticky footer -->
<!-- Wraps everything except footer to push footer to the bottom of the page if there is little content -->
<main class="page-wrapper">

  <csn-header></csn-header>

  <!-- Hero -->
  <section class="position-relative overflow-hidden py-5 mb-4 hero-section"
    style="background: linear-gradient(160deg, #1b4332 0%, #0a2018 55%, #040d07 100%);" data-bs-theme="dark">
    <div class="container position-relative zindex-2 pt-5 pb-md-2 pb-lg-4 pb-xl-5">
      <div class="row pt-3 pb-2 py-md-4">

        <!-- Text -->
        <div class="col-xl-5 col-md-6 pt-lg-5 text-center text-md-start mb-4 mb-md-0">
          <h1 class="display-3 pb-2 pb-sm-3">Make Signs Your Players Will Love</h1>
          <p class="text-body fs-lg d-md-none d-xl-block pb-2 pb-md-0 mb-4 mb-md-5">Get better ratings on UDisc, secure
            more funding, and save yourself some headaches.</p>
          <div class="d-flex justify-content-center justify-content-md-start pb-2 pt-lg-2 pt-xl-0">
            <a routerLink="/signup" class="btn btn-lg btn-primary shadow-primary me-3 me-sm-4">Get Started</a>
            <a routerLink="/contact" class="btn btn-lg btn-outline-secondary">Contact us</a>
          </div>
        </div>

        <!-- Hero visual: real tee sign from the product -->
        <div class="col-xl-7 col-md-6 d-md-flex justify-content-center justify-content-xl-end align-items-center">
          <div class="parallax mx-auto ms-md-0 me-md-n3 hero-sign-stage" style="max-width: 460px; transform: translate3d(0px, 0px, 0px) rotate(0.0001deg); transform-style: preserve-3d; backface-visibility: hidden; pointer-events: none;">
            <!-- Ghost course map behind the sign for depth -->
            <div class="parallax-layer hero-course-map-layer" data-depth="-0.12" style="transform: translate3d(0px, 0px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: absolute; display: block; left: -80px; top: -40px;">
              <img src="assets/base-maps/dog-leg-right.svg" alt="" aria-hidden="true" class="hero-course-map">
            </div>
            <!-- Tee sign: actual CourseSignage product output -->
            <div class="parallax-layer zindex-2" data-depth="0.1" style="transform: translate3d(0px, 0px, 0px); transform-style: preserve-3d; backface-visibility: hidden; position: relative; display: block; left: 0px; top: 0px;">
              <img src="assets/template-signs/simple-sign-template.svg" alt="CourseSignage tee sign preview — hole number, distances, and course map" class="hero-sign-preview">
            </div>
          </div>
        </div>
        <!-- Parallax gfx -->
        <!-- <div class="col-xl-7 col-md-6 d-md-flex justify-content-end"> -->
          <!-- <canvas #canvas id="canvas3d" class="mx-auto ms-md-0 me-md-n5" style="max-width: 675px;"></canvas> -->
        <!-- </div> -->
      </div>
    </div>
  </section>

  <!-- Feature section (Trading) -->
  <section id="features" class="container py-5 my-md-2 my-lg-4 my-xl-5">

    <!-- Text -->
    <h2 class="h1 text-center mx-auto mt-n2 mt-sm-0 pt-md-2" style="max-width: 530px;">Stop Letting Old Tee-Signs Make
      Your Course Look Like #@$%</h2>
    <ul class="list-unstyled d-flex flex-wrap justify-content-center mb-5">
      <li class="d-flex fs-xl mx-3 mt-2 mt-sm-3">
        <i class="bx bx-check lead text-primary mt-1 me-2"></i>
        <span>Create top of the line signs with <strong class="text-primary ms-1">no designer</strong></span>
      </li>
      <li class="d-flex fs-xl mx-3 mt-2 mt-sm-3">
        <i class="bx bx-check lead text-primary mt-1 me-2"></i>
        <span>Keep your signs up to date with <strong class="text-primary ms-1">course changes</strong></span>
      </li>
      <li class="d-flex fs-xl mx-3 mt-2 mt-sm-3">
        <i class="bx bx-check lead text-primary mt-1 me-2"></i>
        <span>Quickly <strong class="text-primary mx-1">re-theme</strong> your signs for
          <strong class="text-primary ms-1">holidays and special events</strong></span>
      </li>
    </ul>

    <!-- Parallax gfx -->
    <div class="position-relative px-4 px-sm-5 mb-3 mb-md-4">
      <img src="assets/img/landing/saas-3/feature-1/main.png" width="1079" class="d-block mx-auto"
        style="border-radius: 1.5rem; box-shadow: 0 1.875rem 7.5rem -.625rem rgba(124,125,152, .2);" alt="Dashboard">
      <div class="position-absolute w-100" style="left: 0; bottom: 13%; padding-right: 74.33%;">
        <img src="assets/img/landing/saas-3/feature-1/popup01.png" width="308" class="rellax d-block"
          style=" border-radius: .75rem; box-shadow: 0 .75rem 3.75rem -.625rem rgba(124,125,152, .2);" alt="Popup"
          data-rellax-percentage="0.5" data-rellax-speed="1" data-disable-parallax-down="lg">
      </div>
      <div class="position-absolute w-100" style="right: 0; top: 12%; padding-left: 74.16%;">
        <img src="assets/img/landing/saas-3/feature-1/popup02.png" width="310" class="rellax d-block"
          style="border-radius: .75rem; box-shadow: -.46875rem 2.25rem 6.5rem 0 rgba(126,123,160, .2);" alt="Popup"
          data-rellax-percentage="0.5" data-rellax-speed="1" data-disable-parallax-down="lg">
      </div>
      <div class="position-absolute w-100" style="right: 0; bottom: 9.4%; padding-left: 64.83%; padding-right: 5.5%;">
        <img src="assets/img/landing/saas-3/feature-1/popup03.png" width="322" class="rellax d-block ms-auto"
          style="border-radius: .75rem; box-shadow: -.46875rem 2.25rem 6.5rem 0 rgba(120,118,148, .14);" alt="Popup"
          data-rellax-percentage="0.5" data-rellax-speed=".5" data-disable-parallax-down="lg">
      </div>
    </div>
  </section>


  <!-- Feature section (App)
  <section class="container pb-5 mb-md-2 mb-lg-4 mb-xl-5">
    <div class="row align-items-center pt-2 pb-3">

      
      <div class="col-md-6 col-xl-5 text-center text-md-start mb-5 mb-md-0">
        <h2 class="h1 pb-2 pb-lg-3">Explore Opportunities with Silicon App</h2>
        <p class="pb-2 mb-4 mb-lg-5">In blandit luctus proin mauris a commodo, dolor diam tempus, aenean magna fusce eu.
          Id porttitor aliquam eget aliquet sagittis eu aut diam ut phasellus sed convallis iaculis neque ultricies
          convallis sed enim.</p>
        <hr>
        <div class="d-flex justify-content-center justify-content-md-between pt-4 pt-lg-5">
          <div class="mx-3 mx-md-0">
            <div class="display-3 text-dark mb-1">23%</div>
            <span>Nulla venenatis everys</span>
          </div>
          <div class="mx-3 mx-md-0">
            <div class="display-3 text-dark mb-1">132b</div>
            <span>Dictum in marko elementum</span>
          </div>
        </div>
      </div>

      
      <div class="col-md-6 offset-xl-1">
        <div class="parallax ratio ratio-1x1 mx-auto" style="max-width: 550px;">
          <div class="parallax-layer position-absolute zindex-2" data-depth="-0.15">
            <img src="assets/img/landing/saas-3/feature-2/avatars.png" alt="Avatar">
          </div>
          <div
            class="parallax-layer d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
            data-depth="0.1">
            <div class="rounded-circle bg-primary" style="width: 70%; height: 70%; opacity: .06;"></div>
          </div>
          <div
            class="parallax-layer d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
            data-depth="0.2">
            <div class="rounded-circle bg-primary" style="width: 55%; height: 55%; opacity: .06;"></div>
          </div>
          <div
            class="parallax-layer d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 zindex-3"
            data-depth="0.4">
            <div class="d-flex justify-content-center align-items-center rounded-circle bg-primary"
              style="width: 93px; height: 93px; box-shadow: 0 .1875rem 1.875rem -.125rem rgba(99,102,241, .95); ">
              <span class="h5 text-light mb-0">400K+</span>
            </div>
          </div>
          <div
            class="parallax-layer d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
            data-depth="0.3">
            <div class="rounded-circle bg-primary" style="width: 40%; height: 40%; opacity: .06;"></div>
          </div>
        </div>
      </div>
    </div>
  </section> -->


  <!-- Feature section (Crypto bank) -->
  <!-- <section class="container pt-2 pt-sm-4 pb-5 mb-md-2 mb-lg-4 mb-xl-5">
    <div class="row align-items-center mb-2 pb-sm-3 pb-md-4">

      
      <div class="col-md-5 col-lg-6 col-xl-5 offset-xl-1 order-md-2 text-center text-md-start mb-5 mb-md-0">
        <h2 class="h1 pb-2 pb-lg-3">Make Your Life a lot Easier with Crypto Bank</h2>
        <p class="pb-2 mb-4 mb-xl-5">Sociis sit risus id. Sit facilisis dolor fermentum vestibulum arcuulvi maecenas
          maecenas pharet tincidunt sollicitudin in pellentesque vitae.</p>
        <hr>
        <div class="d-flex flex-wrap flex-sm-nowrap justify-content-center justify-content-md-between pt-3">
          <img src="assets/img/landing/saas-3/feature-3/binance.svg" width="48" class="d-block m-2 mx-md-0"
            alt="Bitcoin">
          <img src="assets/img/landing/saas-3/feature-3/ens.svg" width="48" class="d-block m-2 mx-md-0" alt="Ens">
          <img src="assets/img/landing/saas-3/feature-3/tether.svg" width="48" class="d-block m-2 mx-md-0" alt="Tether">
          <img src="assets/img/landing/saas-3/feature-3/alqo.svg" width="48" class="d-block m-2 mx-md-0" alt="Alqo">
          <img src="assets/img/landing/saas-3/feature-3/blockfi.svg" width="48" class="d-block m-2 mx-md-0"
            alt="BlockFi">
          <img src="assets/img/landing/saas-3/feature-3/bitcoin.svg" width="48" class="d-block m-2 mx-md-0"
            alt="Bitcoin">
        </div>
      </div>

      
      <div class="col-md-7 col-lg-6 order-md-1">
        <div class="position-relative pt-5" style="max-width: 636px;">
          <img src="assets/img/landing/saas-3/feature-3/popup.png" class="rellax position-absolute top-0 mt-n5"
            alt="Card" data-rellax-percentage="0.5" data-rellax-speed="1" data-disable-parallax-down="lg">
          <img src="assets/img/landing/saas-3/feature-3/dashboard.jpg" class="d-block rounded-3 mt-sm-4 mt-md-0 mt-lg-4"
            alt="Dashboard" style="box-shadow: 0 1.875rem 7.5rem -.625rem rgba(124,125,152, .2);">
        </div>
      </div>
    </div>
  </section> -->


  <!-- How it works (Steps + Video) -->
  <section id="how-it-works" class="container">
    <div class="text-center pb-4 pb-md-0 mb-2 mb-md-5 mx-auto" style="max-width: 530px;">
      <h2 class="h1">How Does It Work?</h2>
      <p class="mb-0">Get a full set of custom course signs in under an hour with no design experience</p>
    </div>

    <!-- Steps -->
    <div class="steps steps-sm steps-horizontal-md steps-center pb-5 mb-md-2 mb-lg-3">
      <div class="step">
        <div class="step-number">
          <div class="step-number-inner">1</div>
        </div>
        <div class="step-body">
          <h3 class="h4 mb-3">Registration </h3>
          <p class="mb-0">Create an account and choose one of our affordable plans</p>
        </div>
      </div>
      <div class="step">
        <div class="step-number">
          <div class="step-number-inner">2</div>
        </div>
        <div class="step-body">
          <h3 class="h4 mb-3">Create a Course</h3>
          <p class="mb-0">Quickly fill out hole and tee details <br /><strong class="text-primary ms-1">Import from
              UDisc coming soon</strong> </p>
        </div>
      </div>
      <div class="step">
        <div class="step-number">
          <div class="step-number-inner">3</div>
        </div>
        <div class="step-body">
          <h3 class="h4 mb-3">Design Hole Maps</h3>
          <p class="mb-0">Use our easy drag-and-drop designer to build your hole maps</p>
        </div>
      </div>
      <div class="step">
        <div class="step-number">
          <div class="step-number-inner">4</div>
        </div>
        <div class="step-body">
          <h3 class="h4 mb-3">Export & Print</h3>
          <p class="mb-0">Export your designs and use your printer of choice.</p>
        </div>
      </div>
    </div>

    <!-- Video -->
    <div class="bg-secondary position-relative rounded-3 overflow-hidden px-4 px-sm-5">
      <div
        class="position-absolute top-50 start-50 w-75 h-75 translate-middle d-flex align-items-center justify-content-center zindex-5">
        <a href="https://www.youtube.com/watch?v=wODsNtortYw"
          class="btn btn-video btn-icon btn-xl bg-white stretched-link" data-bs-toggle="video" aria-label="Play video">
          <i class="bx bx-play"></i>
        </a>
      </div>
      <div class="pt-4 mt-sm-3 px-3 px-sm-5 mx-md-5">
        <img src="assets/img/landing/saas-3/video-cover.png" width="786" class="rellax d-block mx-auto mt-lg-4"
          alt="Card" data-rellax-percentage="0.5" data-rellax-speed="1.1" data-disable-parallax-down="lg">
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="container">
    <div
      class="bg-dark bg-size-cover bg-position-center bg-repeat-0 position-relative overflow-hidden rounded-3 py-lg-3 py-xl-5 px-4 px-lg-5 px-xl-0"
      style="background-image: url(assets/img/landing/saas-3/cta-bg.jpg);" data-bs-theme="dark">
      <div class="row position-relative zindex-2 py-5 my-1 my-md-3">
        <div class="col-md-6">
          <div class="mx-auto" style="max-width: 440px;">
            <h2 class="h1 pb-1 pb-md-3 pb-lg-4">Let's start building some signs!</h2>
            <ul class="list-unstyled fs-lg d-md-none pb-3">
              <li class="d-flex text-body mb-2">
                <i class="bx bx-check lead text-primary me-2" style="margin-top: .125rem;"></i>
                Professional-quality signs with no design experience
              </li>
              <li class="d-flex text-body mb-2">
                <i class="bx bx-check lead text-primary me-2" style="margin-top: .125rem;"></i>
                Print-ready exports for any sign size or format
              </li>
              <li class="d-flex text-body">
                <i class="bx bx-check lead text-primary me-2" style="margin-top: .125rem;"></i>
                Works for any disc golf course, anywhere
              </li>
            </ul>
            <a routerLink="/signup" class="btn btn-lg btn-primary shadow-primary w-100 w-sm-auto">Get Started Now!</a>
          </div>
        </div>
        <div class="col-md-6 pt-lg-3 pt-xl-4">
          <ul class="list-unstyled fs-lg d-none d-md-block">
            <li class="d-flex text-body mb-2">
              <i class="bx bx-check lead text-primary me-2" style="margin-top: .125rem;"></i>
              Professional-quality signs with no design experience
            </li>
            <li class="d-flex text-body mb-2">
              <i class="bx bx-check lead text-primary me-2" style="margin-top: .125rem;"></i>
              Print-ready exports for any sign size or format
            </li>
            <li class="d-flex text-body">
              <i class="bx bx-check lead text-primary me-2" style="margin-top: .125rem;"></i>
              Works for any disc golf course, anywhere
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- Back to top button -->
<a href="#top" class="btn-scroll-top" data-scroll>
  <span class="btn-scroll-top-tooltip text-muted fs-sm me-2">Top</span>
  <i class="btn-scroll-top-icon bx bx-chevron-up"></i>
</a>

<!-- Vendor Scripts -->


<!-- Main Theme Script -->
<!-- <script src="assets/js/theme.min.js"></script> -->

<csn-footer></csn-footer>